var ApprovalStatus = /* @__PURE__ */ ((ApprovalStatus2) => {
  ApprovalStatus2["APPROVED"] = "approved";
  ApprovalStatus2["REJECTED"] = "rejected";
  ApprovalStatus2["NEW"] = "new";
  ApprovalStatus2["REQUEST_APPROVAL"] = "request_approval";
  return ApprovalStatus2;
})(ApprovalStatus || {});
var UserType = /* @__PURE__ */ ((UserType2) => {
  UserType2["CONSUMER"] = "consumer";
  UserType2["DEALER"] = "dealer";
  return UserType2;
})(UserType || {});
var CustomerType = /* @__PURE__ */ ((CustomerType2) => {
  CustomerType2["INDIVIDUAL"] = "INDIVIDUAL";
  CustomerType2["FOREIGN"] = "FOREIGN";
  CustomerType2["BUSINESS"] = "BUSINESS";
  CustomerType2["STATE_BUDGET_UNIT"] = "STATE_BUDGET_UNIT";
  return CustomerType2;
})(CustomerType || {});
var ESchoolGrade = /* @__PURE__ */ ((ESchoolGrade2) => {
  ESchoolGrade2["ELEMENTARY_SCHOOL"] = "ELEMENTARY_SCHOOL";
  ESchoolGrade2["MIDDLE_SCHOOL"] = "MIDDLE_SCHOOL";
  ESchoolGrade2["HIGH_SCHOOL"] = "HIGH_SCHOOL";
  ESchoolGrade2["UNIVERSITY_COLLEGE"] = "UNIVERSITY_COLLEGE";
  return ESchoolGrade2;
})(ESchoolGrade || {});
var EStudentStatus = /* @__PURE__ */ ((EStudentStatus2) => {
  EStudentStatus2["ACTIVE"] = "ACTIVE";
  EStudentStatus2["INACTIVE"] = "INACTIVE";
  return EStudentStatus2;
})(EStudentStatus || {});

export { ApprovalStatus, CustomerType, ESchoolGrade, EStudentStatus, UserType };
